import { CarWrenchIcon } from './CarWrenchIcon';

/**
 * author: Colton Wiscombe
 * id 34DABCA7-B5EF-42DD-9731-ABAA7F3DD322
 * name car-wrench
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-wrench.svg
 * tags
 * - Automotive 
 * - Hardware / Tools 
 */
export const CarRepairIcon = CarWrenchIcon;
export default CarRepairIcon